import eventsApi from './rest.event';
import userApi from './rest.user';

export {
    eventsApi,
    userApi
}